import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset dello scroll ad ogni cambio di rotta/hash.
 * Va montato una sola volta dentro <BrowserRouter>. Non renderizza nulla.
 *
 * Copre:
 *  - navigazione fra pagine (pathname change)
 *  - navigazione hash-based del carosello PMV (#page-N)
 *  - back/forward del browser
 * Comportamento identico su desktop e mobile.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Disabilita lo scroll restoration automatico del browser: la SPA gestisce
    // manualmente il reset per garantire coerenza fra desktop e mobile.
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    // window + documentElement + body per coprire tutti i motori.
    window.scrollTo(0, 0);
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
  }, [pathname, hash]);

  return null;
}
